module.exports = __webpack_public_path__ + "img/donnie-smc.50b3ea5b.jpg";